var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInflexionLogoLp3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -48,
    y: -26,
    width: 1440,
    height: 11522,
    rx: 17,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1820550645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "216.light"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    x: -47.5,
    y: -25.5,
    width: 1439,
    height: 95,
    rx: 19.5,
    fill: "#141414",
    stroke: "#393939"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.3125 39.2207C7.3125 36.0505 8.59654 33.0102 10.8821 30.7686C13.1677 28.527 16.2677 27.2676 19.5 27.2676V39.2207H39V0.970947C39 6.04318 36.9455 10.9077 33.2886 14.4943C29.6316 18.0809 24.6717 20.0958 19.5 20.0958C14.3283 20.0958 9.36838 22.1108 5.71142 25.6974C2.05446 29.284 0 34.1485 0 39.2207H7.3125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.6875 0.970947H19.5V12.924C22.7323 12.924 25.8323 11.6647 28.1179 9.42303C30.4035 7.1814 31.6875 4.14109 31.6875 0.970947Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInflexionLogoLp3);
export default __webpack_public_path__ + "static/media/inflexion-logo-LP3.8657314a57c6ede33ed61b6ed42ff457.svg";
export { ForwardRef as ReactComponent };